// src/utils/committeeFeedHelpers.js
// Helper functions to identify and handle committee feeds

/**
 * Detects if a feed uses the committee API based on its endpoint pattern
 * Committee feeds have endpoints like: '&skip=0&committee=Committee%20on...&chamber=HOUSE'
 * Regular feeds have endpoints like: '&skip=0&schema=...&table=...'
 */
 export const isCommitteeFeed = (feed) => {
    if (!feed) return false;
    
    // Check explicit flag first
    if (feed.useCommitteeAPI === true) return true;
    
    // Check endpoint pattern
    const endpoint = feed.apiEndpoint || feed.apiParams || '';
    
    // Committee feeds have 'committee=' parameter and no 'table=' parameter
    const hasCommitteeParam = endpoint.includes('committee=');
    const hasChamberParam = endpoint.includes('chamber=');
    const hasTableParam = endpoint.includes('table=') || endpoint.includes('table_name=');
    
    return hasCommitteeParam && hasChamberParam && !hasTableParam;
  };
  
  /**
   * Parse committee parameters from endpoint
   */
  export const parseCommitteeParams = (endpoint) => {
    if (!endpoint) return null;
    
    try {
      let cleanEndpoint = endpoint;
      if (cleanEndpoint.startsWith('&') || cleanEndpoint.startsWith('?')) {
        cleanEndpoint = cleanEndpoint.substring(1);
      }
      
      const urlParams = new URLSearchParams(cleanEndpoint);
      return {
        committee: urlParams.get('committee'),
        chamber: urlParams.get('chamber'),
        skip: urlParams.get('skip') || '0'
      };
    } catch (err) {
      console.error('Error parsing committee endpoint:', err);
      return null;
    }
  };
  
  /**
   * Generate the FullFeedPage URL for committee materials
   */
  export const generateCommitteeFeedUrl = (endpoint) => {
    const params = parseCommitteeParams(endpoint);
    
    if (!params || !params.committee) {
      return '/feed/united_states_of_america/committee_materials';
    }
    
    const searchParams = new URLSearchParams();
    searchParams.set('useCommitteeAPI', 'true');
    searchParams.set('committee', params.committee);
    if (params.chamber) {
      searchParams.set('chamber', params.chamber);
    }
    
    return `/feed/united_states_of_america/committee_materials?${searchParams.toString()}`;
  };